import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {storeTemplatesAction} from './template.action'
export class storeTemplateModel{
    templates:any[]
 
 }
 @State<storeTemplateModel>({
     name: 'templates',
     defaults: {
        templates:[]
      }
 })
 @Injectable()
 export class storeTemplatesState {
 
     constructor( ) {
     }
 
     @Selector()
     static getTemplates(state: storeTemplateModel) {
         return state;
     }
     @Action(storeTemplatesAction)
     storeTemplatesAction({getState, patchState}: StateContext<storeTemplateModel>, {payload}: storeTemplatesAction) {
         const state = getState();
         
         patchState({
              templates:[...state.templates,payload]
         });
     }
    } 